import styled from "styled-components";
import { BodyDefault, HeadLine1, HeadLine3, VerySmall } from "../../../components/typography/styled";

export const Container = styled.div`
  display:flex;
  justify-content: space-between;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    width: 100%;
    min-width: 0;
  }
`
export const CreateContainer = styled.div`
  justify-content: space-between;
  display: inline-flex;
  align-items: flex-start;
  padding: 10px 30px 50px 30px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    min-width: 0;
    padding: 10px 16px 40px;
    box-sizing: border-box;
  }
`
export const TitleBig = styled(HeadLine1)`
  color:${({theme}) => theme.palette[850]};
  margin-top: 20px;
  margin-bottom: 20px;
`

export const EstimateContainer = styled.div`
  box-sizing: border-box;
  padding: 15px;
  width: 240px;
  background: ${({theme}) => theme.palette[200]};
  border-radius: 8px;
  margin-top: 20px;

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 100%;
  }
`

export const EstimateTitle = styled(HeadLine3)`
  color:${({theme}) => theme.palette[850]};
`
export const EstimateSum = styled(BodyDefault)`
  color:${({theme}) => theme.palette[850]};
`
export const PerHour = styled(VerySmall)`
  color:${({theme}) => theme.palette[650]};
  margin-left:2px;
  margin-bottom:2px;
`
